import React, {
  ReactElement,
} from 'react';
import {
  Checkbox,
  Loader, Select,
} from 'idsk-react-components';
import './sidePanel.scss';
import { ExpansionPanel } from 'slovlex-idsk-react-components';
import { useParams } from 'react-router';
import { TerminListAdminFilter } from '../../../../../../model/TerminListAdminFilter';
import Secured from '../../../../../Secured';
import UserRoleEnum from '../../../../../../model/currentuser/UserRole';
import { SafeParameterSetter } from '../../../../../../model/SafeParameterSetter';
import useAutorZmenyList from '../../../../../../hooks/useAutorZmenyList';

interface Props {
  filter: TerminListAdminFilter,
  onUpdateField?: SafeParameterSetter<TerminListAdminFilter>;
}

const MobileFilters = ({
  filter,
  onUpdateField,
}: Props): ReactElement => {
  const { tezaurusUuid } = useParams<{ tezaurusUuid: string }>();
  const {
    pouzivatelia,
    pouzivateliaStatus,
  } = useAutorZmenyList(tezaurusUuid);

  return (
    <div className="termin-list-admin-container">
      <ExpansionPanel
        className="first-container"
        title="Stav publikácie"
      >
        <div className="slovlex-idsk-side-panel-input-wrapper">
          <Checkbox
            className="idsk-checkboxes--small idsk-checkbox-no-margin"
            id="publikovany"
            checked={filter.publikovany === undefined ? false : filter.publikovany}
            onChange={e => onUpdateField('publikovany', e.target.checked ? true : undefined)}
          >Publikované
          </Checkbox>
          <Checkbox
            className="idsk-checkboxes--small idsk-checkbox-no-margin"
            id="nepublikovany"
            checked={filter.publikovany === undefined ? false : !filter.publikovany}
            onChange={e => onUpdateField('publikovany', e.target.checked ? false : undefined)}
          >Nepublikované
          </Checkbox>
        </div>
      </ExpansionPanel>
      <Secured allowForRoles={[UserRoleEnum.ADMINISTRATOR_TEZAURUS]}>
        <ExpansionPanel title="Autor poslednej zmeny">
          <div className="slovlex-idsk-side-panel-input-wrapper">
            <Loader loading={pouzivateliaStatus.loading}>
              <Select
                id="autorPoslednejZmeny"
                width="full"
                name="autorPoslednejZmeny"
                value={filter?.autorPoslednejZmeny?.uuid ? filter.autorPoslednejZmeny.uuid : ''}
                onChange={({ target }) => {
                  const selectedPouzivatel = pouzivatelia.find(pouzivatel => pouzivatel.uuid === target.value);
                  onUpdateField('autorPoslednejZmeny', target.value === '' ? undefined : selectedPouzivatel);
                }}
              >
                <option key="Vyberte" value="">Vyberte</option>
                {(pouzivatelia && pouzivatelia?.length > 0) ? (
                  <>
                    {pouzivatelia
                      ?.map(pouzivatel => (
                        <option
                          key={pouzivatel.uuid}
                          value={pouzivatel.uuid}
                        >
                          {pouzivatel.nazov}
                        </option>
                      ))}
                  </>
                ) : (
                  <option key="emptyOption" value="emptyOption" disabled>
                    Nenašiel sa žiadny záznam.
                  </option>
                )}
              </Select>
            </Loader>
          </div>
        </ExpansionPanel>
      </Secured>
    </div>
  );
};

export default MobileFilters;
